module.exports = __webpack_public_path__ + "img/works_kyobo_btm.5eaa5a53.jpg";